import './expo_page.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

import Anapp from './shnapr.png';
import shpp from './shapp.jpg';
import plugin from './geoutilities.jpg';
import gdbves from './gbd_vantage.png';
import { useTranslation } from 'react-i18next';

function Elab_serv() {
    const { t, i18n } = useTranslation();

    const navigate = useNavigate();

    return(

        <div className="main-wrapper">
            <div className="tools-wrapperS2">
                    <h1> {t('pages.elab_sev.els1')}</h1>
                <div className="sez2" >
                    <div className="text-im">
                        {/* Eventuale descrizione finale */}
                        <p>{t('pages.elab_sev.els2')}</p>
                        <p >{t('pages.elab_sev.els3')}</p>
                            <ul className="text-im-list">
                            {/* Lista di paragrafi, evita i <br/> */}
                            {[t('pages.elab_sev.els4'),t('pages.elab_sev.els5'),t('pages.elab_sev.els6')].map((i) => (
                              <li key={i} className="text-im-paragraph">
                                {t(`${i}`)}
                              </li>
                            ))}
                            </ul>
                        <p >{t('pages.elab_sev.els7')}</p>
                            <ul className="text-im-list">
                            {/* Lista di paragrafi, evita i <br/> */}
                            {[t('pages.elab_sev.els8'),t('pages.elab_sev.els9'),t('pages.elab_sev.els10')].map((i) => (
                              <li key={i} className="text-im-paragraph">
                                {t(`${i}`)}
                              </li>
                            ))}
                            </ul>
                        <p >{t('pages.elab_sev.els11')}</p>
                            <ul className="text-im-list">
                            {/* Lista di paragrafi, evita i <br/> */}
                            {[t('pages.elab_sev.els12'),t('pages.elab_sev.els13'),t('pages.elab_sev.els14')].map((i) => (
                              <li key={i} className="text-im-paragraph">
                                {t(`${i}`)}
                              </li>
                            ))}
                            </ul>
                        <p >{t('pages.elab_sev.els15')}</p>
                            <ul className="text-im-list">
                            {/* Lista di paragrafi, evita i <br/> */}
                            {[t('pages.elab_sev.els16'),t('pages.elab_sev.els17'),t('pages.elab_sev.els18')].map((i) => (
                              <li key={i} className="text-im-paragraph">
                                {t(`${i}`)}
                              </li>
                            ))}
                            </ul>
                     {/* Terzo blocco: Navigazione Bottone */}
                      <div className="pricing-button" onClick={() => navigate('/contatti')} style={{ cursor: 'pointer' }}>
                        <div className="ic1-block">
                                <h3 className="preview-title">{t('pages.vests.t18')}</h3>
                            </div>
                      </div>
                  </div>
                </div>
            </div>
        </div>

    );
}


export default Elab_serv;
